import service from './fetchInterceptor';

export const generateLegalDocument = (type, data, docId = null) =>
  service.post('/legal-documents/generate', { type, data, ...(docId && { docId }) });

export const getLegalDocuments = (params) =>
  service.get('/legal-documents', { params });

export const deleteLegalDocument = (id) =>
  service.delete(`/legal-documents/${id}`);
